<template>
  <!-- Modal -->
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="fixed z-10  inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <div
        class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div
          class="z-20 fixed inset-0 bg-black bg-opacity-25 lg:hidden"
          aria-hidden="true"
        ></div>

        <main class="py-10">
          <!-- Page header -->
          <div
            class="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8"
          >
            <div class="flex items-center space-x-5">
              <div class="flex-shrink-0">
                <div class="relative">
                  <img
                    class="h-16 w-16 rounded-full"
                    :src="url + userProfile.name + rest"
                    alt=""
                  />
                  <span
                    class="absolute inset-0 shadow-inner rounded-full"
                    aria-hidden="true"
                  ></span>
                </div>
              </div>
              <div>
                <h1 class="text-2xl font-bold text-gray-900">
                  {{ userProfile.name }}
                </h1>
                <p class="text-sm font-medium text-gray-500">
                  Created At
                  <a href="#" class="text-gray-900">{{
                    formatDate(userProfile.created_at)
                  }}</a>
                </p>
              </div>
            </div>
            <div
              class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3"
            >
              <button
                @click="closeCheckUser()"
                type="button"
                class="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
              >
                Close
              </button>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    target="_blank"
                    v-bind="attrs"
                    v-on="on"
                    :href="`tel: ${userProfile.phone}`"
                    class="mx-2"
                    fab
                    dark
                    small
                    color="#304FFE"
                  >
                    <v-icon dark> mdi-cellphone-nfc </v-icon>
                  </v-btn>
                </template>
                <span>Call Client</span>
              </v-tooltip>
            </div>
          </div>

          <div
            class="mt-8 max-w-5xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3"
          >
            <div class="space-y-6 lg:col-start-1 lg:col-span-2">
              <!-- Description list-->
              <section aria-labelledby="applicant-information-title">
                <div class="bg-white shadow sm:rounded-lg">
                  <div class="px-4 py-5 sm:px-6">
                    <h2
                      id="applicant-information-title"
                      class="text-lg leading-6 font-medium text-gray-900"
                    >
                      Contact Information
                    </h2>
                    <p class="mt-1 max-w-2xl text-sm text-gray-500">
                      Personal details and application.
                    </p>
                  </div>
                  <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
                    <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Email address
                        </dt>
                        <dd class="mt-1 text-sm text-gray-400">
                          <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <input
                              type="text"
                              v-model="userProfile.email"
                              autocomplete="given-name"
                              class="mt-4 p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                            />
                          </div>
                        </dd>
                      </div>

                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Phone
                        </dt>
                        <dd class="mt-1 text-sm text-gray-400">
                          <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <input
                              type="text"
                              v-model="userProfile.phone"
                              autocomplete="given-name"
                              class="mt-4 p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                            />
                          </div>
                        </dd>
                      </div>
                    </dl>
                  </div>

                  <a
                    @click="updateContact(userProfile)"
                    class="block bg-gray-50 text-sm font-medium text-gray-500 text-center px-4 py-4 hover:text-gray-700 sm:rounded-b-lg"
                  >
                    Update contact information
                  </a>
                </div>
              </section>
            </div>

            <section
              aria-labelledby="timeline-title"
              class="lg:col-start-3 lg:col-span-1"
            >
              <form class="mb-6" @submit.prevent="saveTags(userProfile)">
                <label class="block text-sm font-medium text-gray-700">
                  Assign Tags
                </label>
                <div class="mt-1">
                  <multiselect
                    v-model="tagsSelected"
                    :options="tags"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :preserve-search="true"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                  </multiselect>
                </div>

                <button
                  type="submit"
                  class="mt-1 inline-flex items-center justify-center px-4 py-1 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                >
                  Save
                </button>
              </form>

              <div class="bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6">
                <h2
                  id="timeline-title"
                  class="text-lg font-medium text-gray-900"
                >
                  {{ userProfile.name }}´s Tags
                </h2>

                <div class="mt-6 flow-root">
                  <ul class="-mb-8">
                    <li v-for="tag in userProfile.tags" :key="tag.id">
                      <div class="relative pb-8">
                        <span
                          class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200"
                          aria-hidden="true"
                        ></span>
                        <div class="relative flex space-x-3">
                          <div>
                            <span
                              class="h-8 w-8 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                            >
                              <!-- Heroicon name: user -->
                              <svg
                                class="h-5 w-5 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </span>
                          </div>
                          <div
                            class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4"
                          >
                            <div>
                              <p class="text-sm text-gray-500">
                                <a href="#" class="font-medium text-gray-900"
                                  >{{ tag.name }}
                                </a>
                              </p>
                            </div>
                            <div
                              class="text-right text-sm whitespace-nowrap text-gray-500"
                            >
                              <a
                                style="color: red;"
                                @click="removeTag(userProfile, tag)"
                                class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-xs rounded-full text-red-700 bg-white hover:bg-gray-50"
                              >
                                Remove
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>

          <button
            @click="removeUser(userProfile)"
            type="button"
            class="m-4 inline-flex items-center justify-center px-2 py-2 border border-rose-300 shadow-sm text-sm font-medium rounded-md text-rose-700 bg-rose-100 hover:bg-rose-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-rose-100 focus:ring-rose-500"
          >
            Delete
          </button>
        </main>
      </div>
    </div>
  </div>
  <!-- close Modal -->
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
export default {
  components: { Multiselect },
  props: ["tags", "userProfile"],

  data() {
    return {
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=5564eb&color=fff",
      tagsSelected: []
    };
  },

  methods: {
    formatDate(date) {
      return moment.utc(date).format("YYYY-MM-DD");
    },

    closeCheckUser() {
      this.$emit("refresh");
    },

    removeTag(user, tag) {
      window.axios
        .post("/api/removeUserTag", {
          userId: user.id,
          tagId: tag.id
        })
        .then(() => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Tag succesfully removed",
            showConfirmButton: false,
            timer: 1500
          });

          this.$emit("refresh");
        });
    },

    saveTags(user) {
      let updateTag = new FormData();

      $.each(this.tagsSelected, function(key, value) {
        updateTag.append(`tagIds[${key}]`, value.id);
      });

      updateTag.append("userId", user.id);

      window.axios.post("/api/saveUserTags", updateTag).then(() => {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Tag succesfully added",
          showConfirmButton: false,
          timer: 1500
        });

        this.$emit("refresh");
      });
    },

    updateContact(user) {
      window.axios
        .post("/api/contactUpdate/" + user.id, {
          email: user.email,
          phone: user.phone
        })
        .then(() => {
          this.$emit("refresh");
        });
    },

    removeUser(user) {
      window.axios.get("/api/removeContact/" + user.id).then(() => {
        this.$emit("refresh");
      });
    }
  }
};
</script>
